import React from 'react';
// import HeaderContainer from './components/HeaderContainer';
// import { BrowserRouter, Switch, Route } from 'react-router-dom';
import FSM from './components/FSM';

function App() {
  return (
    // <>
    //   <BrowserRouter>
    //     <Switch>
    //       <Route exact path="/">
    //         <HeaderContainer />
    //       </Route>
    //       <Route path="/FSM/:pais?">
    //         <FSM />
    //       </Route>
    //     </Switch>
    //   </BrowserRouter>
    // </>
    <FSM />
    // <HeaderContainer />
  );
}

export default App;
